import dayjs from 'dayjs'
import { getQueryString, getSourceWay } from '@/utils'
import { BussinessType } from '@/utils/enum'
import { useEffect, useState } from 'react'
import Toast from '@df-mobile/toast'
import {
  loadJdPageData,
  loadlywlPageData,
  getPrice,
  createOrder,
} from './service'
import { increaseLoading, decreaseLoading } from '@df-mobile/library2'
// import { SourceDataObj, jdData, WanleData } from "./model";
export const useConfirmDataHooks = () => {
  const [sourceData, setSourceData] = useState<any>()
  const bussinessType = Number(getQueryString('type') || 1)
  const sceneryId = getQueryString('sceneryId')
  const [isLoading, setIsLoading] = useState<boolean>(true)
  useEffect(() => {
    loadData()
  }, [])

  /**加载详情数据 */
  const loadData = () => {
    if (bussinessType == BussinessType.JINGDIAN) {
      const dfPackageId = getQueryString('dfPackageId')
      const dfProductId = getQueryString('dfProductId')
      const dfResourceId = getQueryString('dfResourceId')
      const param = {
        channelId: 4,
        // dfPackageId: 7264,
        // dfProductId: 6389,
        // dfResourceId: 7351,
        dfPackageId,
        dfProductId,
        dfResourceId,
        sceneryId,
      }
      loadJdPageData(param)
        .then((res) => {
          setIsLoading(false)
          if (res?.Data) {
            setSourceData(res?.Data)
          } else {
            setSourceData(null)
          }
        })
        .catch((err) => {
          setIsLoading(false)
        })
      // setSourceData(jdData);
    } else if (bussinessType === BussinessType.WANLE) {
      const id = getQueryString('id')
      const dfProductId = getQueryString('dfProductId')
      const dfPackageId = getQueryString('dfPackageId')
      const departureDate = getQueryString('departureDate')
      const param = {
        id,
        dfProductId,
        dfPackageId,
        departureDate,
        channelId: 4,
      }
      loadlywlPageData(param)
        .then((res) => {
          setIsLoading(false)
          if (res?.Data) {
            setSourceData(res?.Data)
          } else {
            setSourceData(null)
          }
        })
        .catch((err) => {
          setIsLoading(false)
        })
      // setSourceData(WanleData)
    }
  }

  function isString(data: any) {
    return /^string$/.test(typeof data)
  }

  const submitOrder = async (props: any) => {
    const { detail, personArr, priceData, type, selectItem, contactRef, ref } =
      props

    let flag = true
    const isS = type === '1'
    const date = isS ? selectItem?.date : detail?.departureDate
    if (!date) {
      Toast({ content: '请选择日期' })
      return
    }
    if (personArr?.every((m: any) => !m?.value)) {
      Toast({ content: '请选择购买数量' })
      return
    }
    const params: any = {
      basicOrderRequest: {
        amount: priceData?.totalAmount,
        dfPackageId: detail?.dfPackageId,
        dfProductId: detail?.dfProductId,
        // serviceFee: priceData?.totalServiceFee,
        orderResourceList: personArr
          ?.filter((im: any) => im.value)
          ?.map((m: any) => ({
            bandTitle: m?.bandTitle,
            dfResourceId: m?.dfResourceId,
            day: 1,
            endDate: date,
            useDate: date,
            quantity: m.value,
            price: isS ? selectItem?.salePrice : m?.price,
            saleAloneType: isS ? detail?.saleAloneType : m?.saleAloneType,
          })),
        sceneryId,
      },
      businessType: type,
      channelId: 4,
      departureDate: date,
      // sourceSys: 1,             //疑问点
      sourceWay: getSourceWay(),
      //   gatewayParam:{"union":"xusheng002","userCustomer":{"mobile":"187717231","name":"朱成琳","union":"xusheng002","unionUserId":"1600278","userId":6150441}},
    }

    let sourceID: any = []
    try {
      for (var i = 0; i < ref?.current?.length; i++) {
        sourceID = ref?.current[i]?.person?.dfResourceId
        await ref?.current[i]?.form.validateFields()
      }
    } catch (err: any) {
      console.log(err, 'err')
      Object.keys(err).forEach((key) => {
        // if (!err[key] && key === 'personType__cust') {
        //   Toast({content: `请选择证件类型`})
        //   return
        // }
        const questionList = detail?.passengerQuestionList?.find(
          (item: any) => item.dfResourceId === sourceID
        )?.questionList
        const obj = questionList?.find((m: any) => m?.code === key)
        if (!err[key]) {
          Toast({ content: `请填写${obj?.title}` })
          return
        }
      })
      return
    }

    try {
      await contactRef?.current?.validateFields()
    } catch (err: any) {
      console.log(err, 'err')
      if (!err.name) {
        Toast({ content: '请填写联系人信息' })
        return
      }
      if (!err.mobile) {
        Toast({ content: '请填写联系人手机号' })
        return
      }
      if (!/^1\d{10}$/.test(err.mobile)) {
        Toast({ content: '请填写正确的联系人手机号' })
        return
      }
      if (!err.email) {
        Toast({ content: '请填写联系人邮箱' })
        return
      }
      return
    }

    if (!flag) return
    let pushedResource: any = []
    const res = ref?.current?.map((m: any, i: number) => {
      const res1 = m?.form?.getValues()
      const sourceID = m?.person?.dfResourceId
      const questionList = detail?.passengerQuestionList?.find(
        (item: any) => item.dfResourceId === sourceID
      )?.questionList
      // 过滤掉证件类型自定义字段
      const arr = res1
        ?.filter((im: any) => im?.name != 'personType__cust')
        .map((item: any) => {
          const obj = questionList?.find((m: any) => m?.code === item?.name)
          let answer = isString(item?.value) ? item?.value?.trim() : item?.value
          if (obj?.dataType == 'DATE') {
            answer = dayjs(answer).format('YYYY-MM-DD')
          }
          const objItem: any = {
            answer, // 待确认(去空格)
            code: obj?.code,
            questionId: obj?.questionId,
            title: obj?.title,
            passengerUnique: `ans_${i}`,
          }
          if (obj?.dataType == 'ENUM' || obj?.dataType == 'BOOLEAN') {
            const selone = item?.value[0]
            objItem.answer = selone
            objItem.answerSelect = obj?.questionItemList?.find(
              (m: any) => m?.itemId === selone
            )?.title
          }
          if (obj?.dataType == 'TIME') {
            objItem.answer = `${item?.value[0]}:${item?.value[1]}`
          }
          return objItem
        })

      let questionItem: any = questionList?.find(
        (item: any) => item.code == 'A_CUSTOMIZED'
      )
      //只在第一个里面塞出行人数
      if (questionItem && !pushedResource?.includes(sourceID)) {
        const personItem = personArr?.find(
          (m: any) => m?.dfResourceId === sourceID
        )
        pushedResource.push(sourceID)
        arr.push({
          answer: personItem?.value * personItem?.unitQuantity,
          code: questionItem?.code,
          passengerUnique: `ans_${i}`,
          questionId: questionItem?.questionId,
          title: questionItem?.title,
        })
      }
      return { dfResourceId: m?.person?.dfResourceId, arr }
    })
    params.passengerAnswerList = res?.map((m: any) => ({
      dfPackageId: detail?.dfPackageId,
      dfProductId: detail?.dfProductId,
      dfResourceId: m?.dfResourceId,
      questionAnswerList: m?.arr,
    }))
    console.log(params, 'params', contactRef.current?.getValues())
    params.contactsRequiredRequest = contactRef.current
      ?.getValues()
      ?.reduce((obj: any, arr: any) => {
        obj[arr.name] = isString(arr.value) ? arr.value?.trim() : arr.value
        return obj
      }, {})
    // setIsLoading(true);
    increaseLoading()
    const resData = await createOrder(params)
    // setIsLoading(false);
    decreaseLoading()
    if (resData?.Message) {
      Toast({ content: resData?.Message })
      return resData
    }
    if (!resData?.Data?.url) return resData
    window.df_sdk_common.location.href = resData?.Data?.url
    return resData
  }

  return {
    loadData,
    queryPrice: getPrice,
    sourceData,
    isLoading,
    createOrder,
    submitOrder,
  }
}
